import MeasureReductionHandler from "./MeasureReductionHandler";
import CarveReliefHandler from "./CarveReliefHandler";
import BlockingZoneHandler from "./BlockingZoneHandler";
import GlobalReductionHandler from "./GlobalReductionHandler";
import SmootheningHandler from "./SmootheningHandler";
import { TOOLS_CONFIG } from "../../../constants/tools";
import { useToolManager } from "../../../hooks/useToolManager";

const RectificationHandler = () => {
    const { activeTool } = useToolManager();

    return (
    <div className='w-full h-full'>
        {activeTool == TOOLS_CONFIG.MAIN_PROCESS.RECTIFICATION.main_rectification_measure_reduction.id && <MeasureReductionHandler/>}
        {activeTool == TOOLS_CONFIG.MAIN_PROCESS.RECTIFICATION.main_rectification_scoop_recharge.id && <CarveReliefHandler/>}
        {activeTool == TOOLS_CONFIG.MAIN_PROCESS.RECTIFICATION.main_rectification_blocking_zone.id && <BlockingZoneHandler/>}
        {activeTool == TOOLS_CONFIG.MAIN_PROCESS.RECTIFICATION.main_rectification_global_reduction.id && <GlobalReductionHandler/>}
        {activeTool == TOOLS_CONFIG.MAIN_PROCESS.RECTIFICATION.main_rectification_smoothning.id && <SmootheningHandler/>}
      </div>
    )
}
export default RectificationHandler;